/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Aspect_Ratio_HelpInputs */

const en_media_import_aspect_ratio_help = /** @type {(inputs: Media_Import_Aspect_Ratio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the aspect ratio for your media`)
};

const fr_media_import_aspect_ratio_help = /** @type {(inputs: Media_Import_Aspect_Ratio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez le format d'image pour votre media`)
};

const de_media_import_aspect_ratio_help = /** @type {(inputs: Media_Import_Aspect_Ratio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie das Seitenverhältnis für Ihre Medien aus.`)
};

const it_media_import_aspect_ratio_help = /** @type {(inputs: Media_Import_Aspect_Ratio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il rapporto d'aspetto per i tuoi contenuti multimediali`)
};

const ru_media_import_aspect_ratio_help = /** @type {(inputs: Media_Import_Aspect_Ratio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите соотношение сторон для вашего медиафайла.`)
};

const es_media_import_aspect_ratio_help = /** @type {(inputs: Media_Import_Aspect_Ratio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione la relación de aspecto para sus medios`)
};

const zh_cn2_media_import_aspect_ratio_help = /** @type {(inputs: Media_Import_Aspect_Ratio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择媒体的宽高比`)
};

const ja_media_import_aspect_ratio_help = /** @type {(inputs: Media_Import_Aspect_Ratio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのアスペクト比を選択してください`)
};

const hi_media_import_aspect_ratio_help = /** @type {(inputs: Media_Import_Aspect_Ratio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने मीडिया के लिए आस्पेक्ट रेशियो चुनें`)
};

const pt_pt2_media_import_aspect_ratio_help = /** @type {(inputs: Media_Import_Aspect_Ratio_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a proporção da sua mídia.`)
};

/**
* | output |
* | --- |
* | "Select the aspect ratio for your media" |
*
* @param {Media_Import_Aspect_Ratio_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_aspect_ratio_help = /** @type {((inputs?: Media_Import_Aspect_Ratio_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Aspect_Ratio_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_aspect_ratio_help(inputs)
	if (locale === "de") return de_media_import_aspect_ratio_help(inputs)
	if (locale === "it") return it_media_import_aspect_ratio_help(inputs)
	if (locale === "ru") return ru_media_import_aspect_ratio_help(inputs)
	if (locale === "es") return es_media_import_aspect_ratio_help(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_aspect_ratio_help(inputs)
	if (locale === "ja") return ja_media_import_aspect_ratio_help(inputs)
	if (locale === "hi") return hi_media_import_aspect_ratio_help(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_aspect_ratio_help(inputs)
	return en_media_import_aspect_ratio_help(inputs)
});